// checks whether the cookie value is valid e.g. 'basis', 'uitgebreid', 'compleet', 'extensive'
export const isValidCookieValue = (cookieValue: string): boolean => ['all', 'basic'].includes(cookieValue);
